import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import i18n from '@/libs/i18n'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'
import moment from 'moment'

// 3rd party plugins
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/toastification'
import 'firebase/messaging'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.filter('formatDate', (value, dateFormat) => {
  dateFormat = dateFormat || 'DD-MM-YYYY HH:mm'
  if (value) {
    return moment(String(value)).format(dateFormat)
  }
})

Vue.filter('formatDateTime', (value, dateFormat) => {
  dateFormat = dateFormat || 'HH:mm'
  if (value) {
    return moment(String(value)).format(dateFormat)
  }
})
Vue.filter('formatDateD', (value, dateFormat) => {
  dateFormat = dateFormat || 'DD-MM-YYYY'
  if (value) {
    return moment(String(value)).format(dateFormat)
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
